import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqBlockUser');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'chat',
  type: 'post',
  slug: ['blocked_users '],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqBlockUser.js